import { createContext } from 'react';
import { IdbFileInput } from '../util/input/idb-file';

export const RecordingInputContext = createContext<{input?: IdbFileInput}>({});